// Production environment.
import {USE_LOCAL_ENDPOINTS} from "./local_constants";

let api_endpoint = "https://api-dazzle.zebrain.se/api/";
let fast_api_endpoint = "https://api-dazzle.zebrain.se/fast_api/";
// let web_socket_endpoint = "ws://localhost:9003"
let web_socket_endpoint = "wss://backoffice.zebrain.se/wss";
let file_host = "https://platform.zebrain.se/";
let app_host = "https://platform.zebrain.se/";
let meeting_host = "https://meeting.zebrain.se/";
let system: "production"|"staging"|"development" = "production";
let userType = "client";


if (window.location.hostname === "localhost") {
  if (USE_LOCAL_ENDPOINTS) {
    api_endpoint = "http://localhost:8070/api/"
    fast_api_endpoint = "http://localhost:8000/fast_api/"
    file_host = "http://localhost/"
  } else {
    api_endpoint = "https://backoffice.zebrain.se/api/"
    fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/"
    file_host = "https://platform-staging.zebrain.se/"
  }

  if (window.location.port === "1235") {
    app_host = "http://localhost:1235/"
    userType = "coach";
  } else {
    app_host = "http://localhost:1234/"
  }
  meeting_host = "http://localhost:1236/"
  system = "development"
} else if (window.location.hostname === "platform-staging.zebrain.se") {
  api_endpoint = "https://backoffice.zebrain.se/api/"
  fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/"
  file_host = "https://platform-staging.zebrain.se/"
  app_host = "https://platform-staging.zebrain.se/"
  system = "staging"
} else if (window.location.hostname === "coach-staging.zebrain.se") {
  api_endpoint = "https://backoffice.zebrain.se/api/"
  fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/"
  file_host = "https://coach-staging.zebrain.se/"
  app_host = "https://coach-staging.zebrain.se/"
  system = "staging";
  userType = "coach";
} else if (window.location.hostname === "coach.zebrain.se") {
  file_host = "https://coach.zebrain.se/"
  app_host = "https://coach.zebrain.se/"
  userType = "coach"
}

export interface AppConfig {
  TOKEN_NAME: string
  PERSON_TOKEN: string
  USERNAME_TOKEN: string
  API_ENDPOINT: string
  FAST_API_ENDPOINT: string
  WEB_SOCKET_ENDPOINT: string
  FILE_HOST: string
  APP_HOST: string
  MEETING_HOST: string
  SYSTEM: string
  AUTH0_CLIENT_ID: string
  USER_TYPE: string
}

export const CONFIG: AppConfig = {
  TOKEN_NAME: "api_token",
  PERSON_TOKEN: "person_token",
  USERNAME_TOKEN: "username_token",
  API_ENDPOINT: api_endpoint,
  FAST_API_ENDPOINT: fast_api_endpoint,
  WEB_SOCKET_ENDPOINT: web_socket_endpoint,
  FILE_HOST: file_host,
  APP_HOST: app_host,
  MEETING_HOST: meeting_host,
  SYSTEM: system,
  AUTH0_CLIENT_ID: "Ec9P4CVtrm3cIVjUCNou3BMcXXJIPfjm",
  USER_TYPE: userType,
}

export const setUserType = (_userType: "client"|"coach") => {
  if (_userType === "client") {
    if (system === "staging") {
      window.location.href = "https://platform-staging.zebrain.se/";
    } else if (system === "development") {
      window.location.href = "http://localhost:1234/";
    } else {
      window.location.href = "https://platform.zebrain.se/";
    }
  } else {
    if (system === "staging") {
      window.location.href = "https://coach-staging.zebrain.se/";
    } else if (system === "development") {
      window.location.href = "http://localhost:1235/";
    } else {
      window.location.href = "https://coach.zebrain.se/";
    }
  }
}
